var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.083252 7.00016C0.083252 6.71694 0.319546 6.48734 0.611029 6.48734H2.72214C3.01362 6.48734 3.24992 6.71694 3.24992 7.00016V13.154C3.24992 13.4372 3.01362 13.6668 2.72214 13.6668H0.611029C0.319546 13.6668 0.083252 13.4372 0.083252 13.154V7.00016Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30547 9.05144C4.30547 8.76822 4.54177 8.53862 4.83325 8.53862H6.94436C7.23585 8.53862 7.47214 8.76822 7.47214 9.05144V13.154C7.47214 13.4372 7.23585 13.6668 6.94436 13.6668H4.83325C4.54177 13.6668 4.30547 13.4372 4.30547 13.154V9.05144Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5277 4.94888C8.5277 4.66566 8.76399 4.43606 9.05547 4.43606H11.1666C11.4581 4.43606 11.6944 4.66566 11.6944 4.94888V13.154C11.6944 13.4372 11.4581 13.6668 11.1666 13.6668H9.05547C8.76399 13.6668 8.5277 13.4372 8.5277 13.154V4.94888Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 0.846317C12.7499 0.563094 12.9862 0.333496 13.2777 0.333496H15.3888C15.6803 0.333496 15.9166 0.563094 15.9166 0.846317V13.154C15.9166 13.4372 15.6803 13.6668 15.3888 13.6668H13.2777C12.9862 13.6668 12.7499 13.4372 12.7499 13.154V0.846317Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.083252 7.00016C0.083252 6.71694 0.319546 6.48734 0.611029 6.48734H2.72214C3.01362 6.48734 3.24992 6.71694 3.24992 7.00016V13.154C3.24992 13.4372 3.01362 13.6668 2.72214 13.6668H0.611029C0.319546 13.6668 0.083252 13.4372 0.083252 13.154V7.00016Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30547 9.05144C4.30547 8.76822 4.54177 8.53862 4.83325 8.53862H6.94436C7.23585 8.53862 7.47214 8.76822 7.47214 9.05144V13.154C7.47214 13.4372 7.23585 13.6668 6.94436 13.6668H4.83325C4.54177 13.6668 4.30547 13.4372 4.30547 13.154V9.05144Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5277 4.94888C8.5277 4.66566 8.76399 4.43606 9.05547 4.43606H11.1666C11.4581 4.43606 11.6944 4.66566 11.6944 4.94888V13.154C11.6944 13.4372 11.4581 13.6668 11.1666 13.6668H9.05547C8.76399 13.6668 8.5277 13.4372 8.5277 13.154V4.94888Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7499 0.846317C12.7499 0.563094 12.9862 0.333496 13.2777 0.333496H15.3888C15.6803 0.333496 15.9166 0.563094 15.9166 0.846317V13.154C15.9166 13.4372 15.6803 13.6668 15.3888 13.6668H13.2777C12.9862 13.6668 12.7499 13.4372 12.7499 13.154V0.846317Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyze);
export default __webpack_public_path__ + "static/media/Analyze.374cda257aaf903a1456c4c3d1e5ae2b.svg";
export { ForwardRef as ReactComponent };